export default __webpack_public_path__ + "static/media/showcase-img.148b05ff.jpeg";